<template>
  <div class="base-dressing">
    <MainHeader>
      {{$ml.get('Base Dressing')}}
    </MainHeader>

    <div class="general-info">
      <HeadLine>
        {{ $ml.get('General Information') }}
      </HeadLine>
      <div class="th-fields-container">
        <div class="column">
          <ValueField :label="$ml.get('Soil texture')" :value="$ml.get(section.nutrients.data.textureName)"/>
        </div>
        <div class="column">
          <ValueField :label="$ml.get('CEC')" :value="section.nutrients.data.cec + ' ' + $ml.get('meq/100g')"/>
        </div>
      </div>
      <div class="nutrients">
        <ValueField
          :label="nut"
          :value="(section.nutrients.data.data.BDPercents[nut] ? section.nutrients.data.data.BDPercents[nut] : 0) + '%'"
          v-for="nut in [ 'N', 'P', 'K', 'Ca', 'Mg', 'S', 'B', 'Fe', 'Cl' ]"
        />
      </div>
    </div>

    <div class="selected-fertilizers" v-if="section.data.fertilizers.length">
      <HeadLine>
        {{ section.lang.sel }}
      </HeadLine>
      <table class="th-table">
        <tr class="head">
          <td>
          {{$ml.get('Fertilizer')}}
          </td>
          <td>
          {{$ml.get('Amount')}}
          </td>
        </tr>
        <tr v-for="fert in section.data.fertilizers">
          <td>
            {{ $ml.get(fert.name) }}
          </td>
          <td>
          {{ $store.getters['unit/convert']('kg', fert.conc) }} {{$ml.get($store.getters['unit/getLabel']('kg'))}}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import MainHeader from './../components/common/MainHeader';
import HeadLine from './../components/common/HeadLine';
import ValueField from './../components/common/ValueField';

export default {
  components: {
    MainHeader,
    ValueField,
    HeadLine,
  },

  computed: {
    section() {
      return this.$root.data.baseDressing;
    }
  },
}
</script>

<style lang="scss" scoped>

.base-dressing {
  .head-line {
    margin-bottom: 10px;
  }

  .nutrients {
    display: flex;
    flex-direction: row;
    align-content: stretch;

    width: 100%;
    padding-bottom: 20px;

    .value-field {
      flex-grow: 1;
      margin-right: 20px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}

</style>
